import { type FC } from "react";
import {
  Dialog,
  DialogContent,
  LinearProgress,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../DialogHeader";
import { threadTexts } from "./texts";

/**
 * Политика для документа письма: никаких внешних загрузок (трекинг-пиксель
 * раскрыл бы IP сотрудника и факт открытия), только встроенные стили и
 * картинки data:. Мета-тег до разметки письма парсер кладёт в head.
 */
const ORIGINAL_EMAIL_CSP =
  "<meta http-equiv=\"Content-Security-Policy\" content=\"default-src 'none'; img-src data:; style-src 'unsafe-inline'\">";

interface ContentProps {
  html: string | null;
  loading: boolean;
}

/**
 * Содержимое окна: письмо в песочнице, полоса загрузки или «недоступно»,
 * если исходник не пришёл (удалён, ошибка запроса). Отдельно от Dialog,
 * потому что портал Dialog не рендерится на сервере и в тестах.
 */
export const OriginalEmailContent: FC<ContentProps> = ({ html, loading }) => {
  if (loading) return <LinearProgress />;
  if (html === null) {
    return (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ p: 3, textAlign: "center" }}
      >
        {threadTexts.originalUnavailable()}
      </Typography>
    );
  }
  return (
    <iframe
      title={threadTexts.showOriginal()}
      sandbox=""
      referrerPolicy="no-referrer"
      srcDoc={`${ORIGINAL_EMAIL_CSP}${html}`}
      style={{ border: 0, width: "100%", height: "100%" }}
    />
  );
};

/**
 * Исходный HTML входящего письма в песочнице (R14): iframe с sandbox="" не
 * исполняет скрипты, не отправляет формы и не получает доступ к странице,
 * CSP в документе не пускает внешние картинки и стили.
 */
export const OriginalEmailDialog: FC<
  ContentProps & { open: boolean; onClose: () => void }
> = ({ open, html, loading, onClose }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogHeader
      title={threadTexts.showOriginal()}
      onClose={onClose}
      loading={loading}
    />
    <DialogContent
      sx={{ p: 0, height: html !== null && !loading ? "70vh" : "auto" }}
    >
      <OriginalEmailContent html={html} loading={loading} />
    </DialogContent>
  </Dialog>
);
